export const COMMON_LOKALISE_PROJECT_ID = '582644755b56e6abed34f6.20024562'
